// import React from "react";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { addDays, format } from 'date-fns';

// function DateRangePicker({ startDate, totalDays, isDisabled, handleDateChange, name, value }) {
//   // Calculate the end date based on the start date and total days
//   const endDate = addDays(new Date(startDate), totalDays - 1);

//   const onDateChange = (date) => {
//     const formattedDate = format(date, 'yyyy-MM-dd');
//     handleDateChange(formattedDate, name);
//   };

//   return (
//     <div>
//       <DatePicker
//         selected={value ? new Date(value) : null}
//         onChange={onDateChange}
//         minDate={new Date(startDate)}
//         maxDate={endDate}
//         disabled={isDisabled}
//         dateFormat="dd-MMMM-yyyy"  // Set the display format to dd-Month Name-yyyy
//         className="form-control w-100"  // Apply Bootstrap's form-control class
//         placeholderText={
//           isDisabled
//             ? "dd-mm-yyyy"
//             : `Select Date`
//         }
//       />
//     </div>
//   );
// }

// export default DateRangePicker;
import React, { useContext, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addDays, format } from 'date-fns';
import { currentDateAndTime } from "../Constants/constants";
import { ConfigContext } from "../Context/ConfigContext";

function DateRangePicker({ startDate = currentDateAndTime()?.split(" ")[0] , totalDays, isDisabled, handleDateChange, name, value, dateArray = [] }) {
  const {backdateRows, setBackdateRows}=useContext(ConfigContext);
  useEffect(() => {
    console.log("DateRangePicker Mounted or Updated", { startDate, totalDays, dateArray, backdateRows });
  }, [startDate, totalDays, dateArray]);

  // Calculate the end date based on the start date and total days
  const minDate = new Date(startDate);
  const maxDate = addDays(new Date(startDate), totalDays - 1);

  // Convert date array to Date objects
  let includeDates = backdateRows.map(date => new Date(date));
  
  

  console.log("Processed includeDates=>>>", includeDates);

  const onDateChange = (date) => {
    const formattedDate = format(date, 'yyyy-MM-dd');
    handleDateChange(formattedDate, name);
  };

  // Filter to allow only dates in the array or within the min-max range
  const filterDate = (date) => {
    const isInArray = includeDates.some(includedDate => format(includedDate, 'yyyy-MM-dd') === format(date, 'yyyy-MM-dd'));
    const isInRange = (date >= minDate && date <= maxDate);
    return isInArray || isInRange;
  };

  return (
    <div>
      <DatePicker
        selected={value ? new Date(value) : null}
        onChange={onDateChange}
        minDate={minDate}
        maxDate={maxDate}
        disabled={isDisabled}
        dateFormat="dd-MMMM-yyyy"  // Set the display format to dd-Month Name-yyyy
        className="form-control"  // Apply Bootstrap's form-control class
        filterDate={filterDate}   // Apply the custom filter logic
        placeholderText={
          isDisabled
            ? "Date selection is disabled"
            : `Select a date within the range or specific dates`
        }
        includeDates={includeDates.concat(
          Array.from({ length: totalDays }, (_, i) => addDays(minDate, i))
        )} // Include dates from the array and the range
      />
    </div>
  );
}

export default DateRangePicker;


